import React, { useState } from "react";
import AuthUser from "../../services/AuthUser";
import defaultUserAvatar from "../../assets/user-avatar.jpg";
import { NotificationManager } from "react-notifications";
import "./profile.styles.scss";
import {
  Form,
  ButtonToolbar,
  Button,
  Uploader,
  Message,
  Loader,
  useToaster,
  Schema,
} from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { API_URL } from "../../shared/constant";

const { StringType } = Schema.Types;
const chagePasswordModel = Schema.Model({
  old_password: StringType().isRequired("This field is required."),
  password: StringType().isRequired("This field is required."),
  confirm_password: StringType()
    .addRule((value, data) => {
      if (value !== data.password) {
        return false;
      }

      return true;
    }, "The two passwords do not match")
    .isRequired("This field is required."),
});

const profileModel = Schema.Model({
  name: StringType().isRequired("This field is required."),
  address: StringType().isRequired("This field is required."),
});

function previewFile(file, callback) {
  const reader = new FileReader();
  reader.onloadend = () => {
    callback(reader.result);
  };
  reader.readAsDataURL(file);
}

const Profile = () => {
  const { http, user, token } = AuthUser();
  const toaster = useToaster();
  const [uploading, setUploading] = React.useState(false);
  const [fileInfo, setFileInfo] = React.useState(null);

  const [changePasswordFormValue, setChangePasswordFormValue] = useState({
    old_password: "",
    password: "",
    confirm_password: "",
  });

  const [profileFormValue, setProfileFormValue] = useState({
    name: user.name,
    address: user.address,
  });

  const handleProfileSubmit = (data) => {
    http
      .post(API_URL.UPDATE_PROFILE, data)
      .then((res) => {
        if (res.data.code === 200) {
          NotificationManager.success(res.data.msg, "Successful!", 2000);
          user.name = res.data.data.name;
          user.address = res.data.data.address;
          user.photo = res.data.data.photo;
          setProfileFormValue({
            name: user.name,
            address: user.address,
          });
          sessionStorage.setItem("user", JSON.stringify(res.data.data));
        } else {
          NotificationManager.error(res.data.msg, "Error!");
        }
      })
      .catch((err) => {
        NotificationManager.error("Error while update profile!", "Error!");
      });
  };

  const handleChangePasswordSubmit = (data) => {
    http
      .post(API_URL.CHANGE_PASSWORD, data)
      .then((res) => {
        if (res.data.code === 200) {
          NotificationManager.success(res.data.msg, "Successful!", 2000);
          setChangePasswordFormValue({
            old_password: "",
            password: "",
            confirm_password: "",
          });
        } else {
          NotificationManager.error(res.data.msg, "Error!");
        }
      })
      .catch((err) => {
        NotificationManager.error("Error while changing passwor!", "Error!");
      });
  };

  return (
    <section className="header-padding">
      <div className="container rounded bg-white">
        <div className="row">
          <div className="col-md-3 border-right">
            <div className="d-flex flex-column align-items-center text-center p-3 py-5">
              <Uploader
                multiple={false}
                name="photo"
                fileListVisible={false}
                listType="picture"
                action={API_URL.UPDATE_PROFILE}
                accept="image/*"
                headers={{
                  "Content-type": "application/json",
                  "Bearer-Token": token,
                }}
                onUpload={(file) => {
                  setUploading(true);
                  previewFile(file.blobFile, (value) => {
                    setFileInfo(value);
                  });
                }}
                onSuccess={(response, file) => {
                  setUploading(false);
                  user.photo = fileInfo;
                  sessionStorage.setItem("user", JSON.stringify(user));
                  toaster.push(
                    <Message type="success">{response.msg}</Message>
                  );
                }}
                onError={() => {
                  setFileInfo(null);
                  setUploading(false);
                  toaster.push(<Message type="error">Upload failed</Message>);
                }}
              >
                <button style={{ width: 150, height: 150 }}>
                  {uploading && <Loader backdrop center />}
                  {fileInfo ? (
                    <img
                      src={fileInfo}
                      width="100%"
                      height="100%"
                      alt={user.name}
                    />
                  ) : (
                    <img
                      src={user.photo ? user.photo : defaultUserAvatar}
                      width="100%"
                      height="100%"
                      alt={user.name}
                    />
                  )}
                </button>
              </Uploader>
              <br />
              <span className="font-weight-bold">{user.name}</span>
              <span className="text-black-50">{user.email}</span>
              <span className="text-black-50">{user.phone}</span>
            </div>
          </div>
          <div className="col-md-5 border-right">
            <div className="p-3 py-5">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="text-right">Profile Settings</h4>
              </div>
              <Form
                fluid
                model={profileModel}
                onSubmit={() => handleProfileSubmit(profileFormValue)}
                onChange={setProfileFormValue}
                formValue={profileFormValue}
              >
                <Form.Group>
                  <Form.ControlLabel className="labels">
                    Full Name
                  </Form.ControlLabel>
                  <Form.Control name="name" />
                </Form.Group>
                <Form.Group>
                  <Form.ControlLabel className="labels">
                    Email Address
                  </Form.ControlLabel>
                  <Form.Control name="email" value={user.email} disabled />
                </Form.Group>
                <Form.Group>
                  <Form.ControlLabel className="labels">
                    Phone Number
                  </Form.ControlLabel>
                  <Form.Control name="phone" value={user.phone} disabled />
                </Form.Group>
                <Form.Group>
                  <Form.ControlLabel className="labels">
                    Address
                  </Form.ControlLabel>
                  <Form.Control name="address" />
                </Form.Group>
                <ButtonToolbar>
                  <Button
                    type="submit"
                    appearance="ghost"
                    className="btn btn-thm"
                  >
                    Save Profile
                  </Button>
                </ButtonToolbar>
              </Form>
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 py-5">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="text-right">Change Password</h4>
              </div>
              <Form
                fluid
                onSubmit={() =>
                  handleChangePasswordSubmit(changePasswordFormValue)
                }
                model={chagePasswordModel}
                onChange={setChangePasswordFormValue}
                formValue={changePasswordFormValue}
              >
                <Form.Group>
                  <Form.ControlLabel className="labels">
                    Old Password
                  </Form.ControlLabel>
                  <Form.Control
                    type="password"
                    autoComplete="off"
                    name="old_password"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.ControlLabel className="labels">
                    New Password
                  </Form.ControlLabel>
                  <Form.Control
                    type="password"
                    autoComplete="off"
                    name="password"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.ControlLabel className="labels">
                    Confirm Password
                  </Form.ControlLabel>
                  <Form.Control
                    type="password"
                    autoComplete="off"
                    name="confirm_password"
                  />
                </Form.Group>
                <ButtonToolbar>
                  <Button
                    type="submit"
                    appearance="ghost"
                    className="btn btn-thm"
                  >
                    Change
                  </Button>
                </ButtonToolbar>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Profile;
